import script from "./KbsMyCreated.vue?vue&type=script&setup=true&lang=js"
export * from "./KbsMyCreated.vue?vue&type=script&setup=true&lang=js"

import "./KbsMyCreated.vue?vue&type=style&index=0&id=0ebecb3d&scoped=true&lang=css"

import exportComponent from "D:\\Workspace-idea\\vue-space\\hwoms-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0ebecb3d"]])

export default __exports__